import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { SingleVariableListComponent } from '../../single-variable/single-variable-list/single-variable-list.component';
import { TabComponent } from '../../../../../ui-components/lib/tabs/tab/tab.component';
import { TabsComponent } from '../../../../../ui-components/lib/tabs/tabs.component';
import {
  injectFloatingLayout,
  injectFloatingPageClasses,
  injectSystemTabsLayout,
  provideSystemTabsLayout,
} from '../../../../common/helpers/system-tabs-layout/system-tabs-layout';

@Component({
  selector: 'lib-user-management-variable',
  imports: [
    NgTemplateOutlet,
    TranslocoPipe,
    TabComponent,
    TabsComponent,
    SingleVariableListComponent,
  ],
  providers: [provideSystemTabsLayout()],
  templateUrl: './user-management-variable.component.html',
  styleUrl: './user-management-variable.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class UserManagementVariableComponent {
  protected readonly floating = injectFloatingLayout();
  protected readonly floatingPageClasses = injectFloatingPageClasses();
  protected readonly systemTabs = injectSystemTabsLayout();
}
